import {
  ApiBankCell,
  ApiBond,
  ApiBrokerageAccount,
  ApiCentralizedWallet,
  ApiCommercialRealEstate,
  ApiCommodityAssetToken,
  ApiDebitAccount,
  ApiDecentralizedWallet,
  ApiExchangeOptions,
  ApiForwards,
  ApiFutures,
  ApiJewelry,
  ApiLand,
  ApiLegalEntity,
  ApiMetalAccount,
  ApiMyFund,
  ApiOverTheCounterOptions,
  ApiPreciousGemstones,
  ApiPublicFund,
  ApiResidentialRealEstate,
  ApiSecuritiesAndStocks,
} from '../generated/data-contracts';
import {
  ApiCreateWillParticipantDto,
  ApiProfileWithMainUserResponse,
  ApiScopeResponse,
} from '../generated/data-contracts';

export enum ProfileType {
  Assistant = 'ASSISTANT',
  Beneficiary = 'BENEFICIARY',
  MainUser = 'MAIN_USER',
}

export type IwRole = ApiCreateWillParticipantDto['role'];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ApiCurrencyCode = any; // enum with currencies code

export type AccountStatus = ApiProfileWithMainUserResponse['status'];

export type AccountScopes = ApiScopeResponse['scopeType'][];

export type AiAsset =
  | ApiDebitAccount
  | ApiResidentialRealEstate
  | ApiCommercialRealEstate
  | ApiLand
  | ApiLegalEntity
  | ApiJewelry
  | ApiBankCell
  | ApiMetalAccount
  | ApiCentralizedWallet
  | ApiDecentralizedWallet
  | ApiPreciousGemstones
  | ApiCommodityAssetToken
  | ApiBrokerageAccount
  | ApiSecuritiesAndStocks
  | ApiBond
  | ApiExchangeOptions
  | ApiOverTheCounterOptions
  | ApiFutures
  | ApiForwards
  | ApiMyFund
  | ApiPublicFund;
